import { useEffect, useState } from "react";
import { fetchACHDDataWithUTR } from "../Api/AchdDataWithUTR";
import { Container, Table, Row, Col } from "react-bootstrap";

import { toast } from "react-toastify";
import moment from "moment";

const AchdDataWithUTR = () => {
  const [achdData, setAchdData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const loadACHDData = async () => {
      setIsLoading(true);
      try {
        const data = await fetchACHDDataWithUTR();
        setAchdData(data || []);
      } catch (error) {
        toast.error(`Error Fetching ACHD Data with UTR: ${error.message}`);
      } finally {
        setIsLoading(false);
      }
    };

    loadACHDData();
  }, []);

  return (
    
      <div className="main-content expand">
        <Container fluid className="list-container">
          <Row className="align-items-center mb-3">
            <Col>
              <span className="list-title">ACHD Data with UTR No.</span>
            </Col>
          </Row>

          {isLoading ? (
            <p>Loading data...</p>
          ) : achdData.length > 0 ? (
            <div className="table-wrapper">
              <div className="table-scroll-container">
                <Table bordered hover className="data-table">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>ID</th>
                      <th>Doc No</th>
                      <th>Doc FY</th>
                      <th>Doc FM</th>
                      <th>Doc CC</th>
                      <th>Posting Date</th>
                      <th>Document Date</th>
                      <th>Ref No</th>
                      <th>Reporting WBS</th>
                      <th>Created On</th>
                      <th>Entered By</th>
                      <th>Document Type</th>
                      <th>Approval Status</th>
                      <th>UTR Number</th>
                      <th>UTR Updated By</th>
                      <th>UTR Updated On</th>
                    </tr>
                  </thead>
                  <tbody>
                    {achdData.map((item, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{item.id}</td>
                        <td>{item.docno}</td>
                        <td>{item.docfy}</td>
                        <td>{item.docfm}</td>
                        <td>{item.doccc}</td>
                        <td>{moment(item.postingDate).format('L')}</td>
                        <td>{moment(item.documentDate).format('L')}</td>
                        <td>{item.refNo}</td>
                        <td>{item.reportingWbs}</td>
                        <td>{moment(item.createdOn).format('L LT')}</td>
                        <td>{item.enteredBy}</td>
                        <td>{item.documentType}</td>
                        <td>{item.approvalStatus}</td>
                        <td>{item.utrNumber}</td>
                        <td>{item.utrUpdatedBy}</td>
                        <td>{moment(item.utrUpdatedOn).format('L LT')}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            </div>
          ) : (
            <p className="no-data">No ACHD data with UTR found.</p>
          )}
        </Container>
      </div>
    
  );
};

export default AchdDataWithUTR;